import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-3" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "pivotColName",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-3" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "pivotColValue",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-col-3" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "pivotRowName",
  class: "kn-material-input-label"
}
const _hoisted_11 = { class: "p-field-checkbox p-col-3" }
const _hoisted_12 = { for: "pivotIsNumRows" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_15 = { class: "p-field p-col-3" }
const _hoisted_16 = { class: "p-float-label" }
const _hoisted_17 = {
  for: "persistTableName",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Card = _resolveComponent("Card")
  const _component_DatasetScheduler = _resolveComponent("DatasetScheduler")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
      start: _withCtx(() => [
        _createVNode(_component_InputSwitch, {
          modelValue: _ctx.isTransformable,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isTransformable = $event)),
          onChange: _ctx.setTransformationType,
          class: "p-mr-2"
        }, null, 8, ["modelValue", "onChange"]),
        _createVNode("span", null, _toDisplayString(_ctx.$t('managers.datasetManagement.pivotTransformer')), 1)
      ]),
      _: 1
    }),
    (_ctx.isTransformable)
      ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
          content: _withCtx(() => [
            _createVNode("form", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("span", _hoisted_3, [
                  _createVNode(_component_InputText, {
                    id: "pivotColName",
                    class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.pivotColName.$invalid && _ctx.v$.dataset.pivotColName.$dirty
                            }],
                    type: "text",
                    modelValue: _ctx.v$.dataset.pivotColName.$model,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.pivotColName.$model = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.dataset.pivotColName.$touch())),
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.datasetManagement.pivotColName')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.dataset.pivotColName,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.pivotColName') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("span", _hoisted_6, [
                  _createVNode(_component_InputText, {
                    id: "pivotColValue",
                    class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.pivotColValue.$invalid && _ctx.v$.dataset.pivotColValue.$dirty
                            }],
                    type: "text",
                    modelValue: _ctx.dataset.pivotColValue,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dataset.pivotColValue = $event)),
                    onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.dataset.pivotColValue.$touch())),
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.datasetManagement.pivotColValue')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.dataset.pivotColValue,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.pivotColValue') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("span", _hoisted_9, [
                  _createVNode(_component_InputText, {
                    id: "pivotRowName",
                    class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.pivotRowName.$invalid && _ctx.v$.dataset.pivotRowName.$dirty
                            }],
                    type: "text",
                    modelValue: _ctx.dataset.pivotRowName,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dataset.pivotRowName = $event)),
                    onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.dataset.pivotRowName.$touch())),
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.datasetManagement.pivotRowName')) + " *", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.dataset.pivotRowName,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.pivotRowName') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("span", _hoisted_11, [
                _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('managers.datasetManagement.pivotIsNumRows')), 1),
                _createVNode(_component_Checkbox, {
                  id: "pivotIsNumRows",
                  class: "p-ml-2",
                  modelValue: _ctx.dataset.pivotIsNumRows,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dataset.pivotIsNumRows = $event)),
                  binary: true,
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('touched')))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-mt-3" }, {
      start: _withCtx(() => [
        _createVNode(_component_InputSwitch, {
          modelValue: _ctx.dataset.isPersistedHDFS,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dataset.isPersistedHDFS = $event)),
          class: "p-mr-2",
          onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('touched')))
        }, null, 8, ["modelValue"]),
        _createVNode("span", null, _toDisplayString(_ctx.$t('managers.datasetManagement.isPersistedHDFS')), 1)
      ]),
      _: 1
    }),
    (_ctx.dataset.dsTypeCd != 'Flat')
      ? (_openBlock(), _createBlock("div", _hoisted_13, [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-mt-3" }, {
            start: _withCtx(() => [
              _createVNode(_component_InputSwitch, {
                modelValue: _ctx.dataset.isPersisted,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.dataset.isPersisted = $event)),
                disabled: _ctx.disablePersist,
                class: "p-mr-2",
                onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["modelValue", "disabled"]),
              _withDirectives(_createVNode("span", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.isPersisted')), 1)
              ], 512), [
                [
                  _directive_tooltip,
                  { value: _ctx.$t('managers.datasetManagement.peristenceWarning'), disabled: !_ctx.disablePersist },
                  void 0,
                  { top: true }
                ]
              ])
            ]),
            _: 1
          }),
          (_ctx.dataset.isPersisted)
            ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
                content: _withCtx(() => [
                  _createVNode("form", _hoisted_14, [
                    _createVNode("div", _hoisted_15, [
                      _createVNode("span", _hoisted_16, [
                        _createVNode(_component_InputText, {
                          id: "persistTableName",
                          class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.dataset.persistTableName.$invalid && _ctx.v$.dataset.persistTableName.$dirty
                                }],
                          type: "text",
                          modelValue: _ctx.dataset.persistTableName,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.dataset.persistTableName = $event)),
                          onBlur: _cache[18] || (_cache[18] = ($event: any) => (_ctx.v$.dataset.persistTableName.$touch())),
                          onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('touched')))
                        }, null, 8, ["modelValue", "class"]),
                        _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('managers.datasetManagement.persistTableName')) + " *", 1)
                      ]),
                      _createVNode(_component_KnValidationMessages, {
                        class: "p-mt-1",
                        vComp: _ctx.v$.dataset.persistTableName,
                        additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.persistTableName') }
                      }, null, 8, ["vComp", "additionalTranslateParams"])
                    ])
                  ]),
                  (_ctx.isAbleToSeeIsScheduledToolbar)
                    ? (_openBlock(), _createBlock(_component_Toolbar, {
                        key: 0,
                        class: "kn-toolbar kn-toolbar--default p-mt-3"
                      }, {
                        start: _withCtx(() => [
                          _createVNode(_component_InputSwitch, {
                            modelValue: _ctx.dataset.isScheduled,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.dataset.isScheduled = $event)),
                            class: "p-mr-2",
                            onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('touched')))
                          }, null, 8, ["modelValue"]),
                          _createVNode("span", null, _toDisplayString(_ctx.$t('managers.datasetManagement.isScheduled')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isAbleToSeeDatasetScheduler)
                    ? (_openBlock(), _createBlock(_component_DatasetScheduler, {
                        key: 1,
                        selectedDataset: _ctx.dataset,
                        schedulingData: _ctx.schedulingData
                      }, null, 8, ["selectedDataset", "schedulingData"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}